import { useMemo, useRef } from 'react';
import { Doughnut } from 'react-chartjs-2';
import { ChartOptions } from 'chart.js';
import { theme } from '../../styles/theme';


interface Props {
  percent: number
}

export const Chart_Percent = ({percent}: Props) => {

  const ref = useRef({
    arcBackgroundColor: theme.colors.black_bg2
  }).current

  const data = useMemo(() => {
    const result = {
      datasets: [
        {
          data: [percent, 100 - percent],
          backgroundColor: [theme.colors.yellowgreen, "transparent"],
          borderColor: "transparent",
          borderRadius: 14,
          borderWidth: 4,
        }
      ]
    }

    return result
  }, [percent])

  const options = useRef({
    cutout: "80%",
    plugins: {
      title: {
        display: false
      },
      legend: {
        display: false
      },
      datalabels: {
        display: false,
      },
      tooltip: {
        enabled: false,
      }
    },
  } as ChartOptions<"doughnut">).current

  const plugins = useRef([
    {
      id: "backgroundCircle",
      // @ts-expect-error ignore
      beforeDatasetDraw(chart, args, pluginOptions) {
        const {ctx} = chart
        ctx.save()
        const {x, y, innerRadius, outerRadius} = chart.getDatasetMeta(0).data[0],
              width = outerRadius - innerRadius,
              angle = Math.PI / 180
        ctx.beginPath()
        ctx.lineWidth = width
        ctx.strokeStyle = ref.arcBackgroundColor
        ctx.arc(x, y, outerRadius - width / 2, 0, angle * 360, false)
        ctx.stroke()
      }
    }
  ]).current

  return (
    <Doughnut data={data} options={options} plugins={plugins}/>
  )
}